import { isEqual } from "lodash-es";
import { mapComparableFinances } from "web_myplann/Finances/Helpers/mapComparableFinances";
import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";

type HasUnsavedFinanceDraftParams = {
	draft: FinanceState;
	saved: FinanceState;
	isSavedLoaded: boolean;
};

export const hasUnsavedFinanceDraft = ({
	draft,
	saved,
	isSavedLoaded,
}: HasUnsavedFinanceDraftParams) =>
	isSavedLoaded &&
	!isEqual(mapComparableFinances(draft), mapComparableFinances(saved));
